import { c as _c } from "react/compiler-runtime";
import type { TooltipActionType } from '@cc-shopping/platform-analytics/types';
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { LogoBadge as Badge } from '@cc-shopping/ui/primitives/Logo';
import { Box } from '@mui/material';
import { SummaryTableRatingText } from '../SummaryTableRatingText';
export function RatingTitleDriverGroupImprovements(t0) {
  const $ = _c(7);
  const {
    handleTooltipClickPageAction,
    segmentActionSection
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      whiteSpace: "nowrap",
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Badge style={{
      width: "18px",
      height: "18px"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SummaryTableRatingText />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: "20px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== handleTooltipClickPageAction || $[5] !== segmentActionSection) {
    t5 = <Box display="flex" alignItems="center" sx={t1}>{t2}Rating<InfoTooltip position="bottom" text={t3} ariaLabel="How are NerdWallet's ratings determined?" maxWidth="19.375rem" minHeight={0} minWidth={0} containerStyles={t4} triggerIconHeight={18} triggerIconWidth={18} onOpen={() => handleTooltipClickPageAction("open", segmentActionSection)} onClose={() => handleTooltipClickPageAction("close", segmentActionSection)} onBlur={() => handleTooltipClickPageAction("close", segmentActionSection)} /></Box>;
    $[4] = handleTooltipClickPageAction;
    $[5] = segmentActionSection;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}